var CryptoJS = require("crypto-js");
import appInit from "@nfc/js/scripts/app";

export default {
    install: (app, options) => {
        app.config.globalProperties.$methods = {
            buttonScroll() {
                $(".stick-button").fadeOut();
                $(document).scroll(function () {
                    var y = $(this).scrollTop();
                    if (y > 200) {
                        $(".stick-button").fadeIn();
                    } else {
                        $(".stick-button").fadeOut();
                    }
                });
            },
            decrypt(data) {
                var Sha256 = CryptoJS.SHA256;
                var Hex = CryptoJS.enc.Hex;
                var Utf8 = CryptoJS.enc.Utf8;
                var Base64 = CryptoJS.enc.Base64;
                var AES = CryptoJS.AES;
                let key = Sha256(process.env.MIX_DECRYPT_KEY)
                    .toString()
                    .toString(Hex)
                    .substr(0, 32);
                let iv = Sha256(process.env.MIX_DECRYPT_IV)
                    .toString()
                    .toString(Hex)
                    .substr(0, 16);
                // Encryption
                try {
                    var output = AES.decrypt(atob(data), Utf8.parse(key), {
                        iv: Utf8.parse(iv),
                    }).toString(Utf8); // First Base64 encoding, by default (see 1.)
                    return JSON.parse(output);
                } catch (error) {
                    return null;
                }
            },
            encrypt(data) {
                if (process.env.MIX_DECRYPT_ENABLE === "true") {
                    var Sha256 = CryptoJS.SHA256;
                    var Hex = CryptoJS.enc.Hex;
                    var Utf8 = CryptoJS.enc.Utf8;
                    var Base64 = CryptoJS.enc.Base64;
                    var AES = CryptoJS.AES;
                    let key = Sha256(process.env.MIX_DECRYPT_KEY)
                        .toString()
                        .toString(Hex)
                        .substr(0, 32);
                    let iv = Sha256(process.env.MIX_DECRYPT_IV)
                        .toString()
                        .toString(Hex)
                        .substr(0, 16);
                    // Encryption
                    var output = AES.encrypt(
                        JSON.stringify(data),
                        Utf8.parse(key),
                        {
                            iv: Utf8.parse(iv),
                        }
                    ).toString(); // First Base64 encoding, by default (see 1.)
                    var output2ndB64 = Utf8.parse(output).toString(Base64); // Second Base64 encoding (see 1.)
                    return output2ndB64;
                }
                return data;
            },
            errorHandler(error) {
                let message = "";
                if (error.response) {
                    let handler = error.response.decode ?? error.response;
                    console.log(handler);
                    if (handler.data.error != undefined) {
                        let errors = handler.data.error;
                        if (typeof errors !== "string") {
                            let validations = Object.keys(errors);
                            console.log(errors);
                            validations.forEach((element) => {
                                errors[element].forEach((validate) => {
                                    message = validate + "<br/>" + message;
                                });
                            });
                        } else {
                            message = errors;
                        }
                    }
                }
                return message;
            },
            logout() {
                axios
                    .post("/api/logout")
                    .then((response) => {
                        localStorage.removeItem("csrf_tokenizer");
                        localStorage.removeItem("access_token");
                        localStorage.removeItem("auth-token");
                        window.location.reload();
                    })
                    .catch((error) => {
                        localStorage.removeItem("csrf_tokenizer");
                        localStorage.removeItem("access_token");
                        localStorage.removeItem("auth-token");
                        window.location.reload();
                    });
            },
            tooltip() {
                appInit();
            },
            inactivity(response) {
                Swal.fire({
                    title: "La sesión a finalizado por inactividad",
                    text: "Sera redirigido a la página de autenticación",
                    icon: "warning",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Aceptar",
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                });
            },
            generateUUID() {
                var d = new Date().getTime();
                var uuid = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(
                    /[xy]/g,
                    function (c) {
                        var r = (d + Math.random() * 16) % 16 | 0;
                        d = Math.floor(d / 16);
                        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
                    }
                );
                return uuid;
            },
            presentLoading() {
                $(".content").preloader({
                    zIndex: "100000",
                    text: "Procesando . . .",
                });
            },
            dismissLoading() {
                $(".content").preloader("remove");
            },
            /**
             *
             * @param {File} file - El archivo cargado (ej: event.target.files[0])
             * @param {string} selector - Selector para obtener el/los elementos a través de clase o id
             * @param {function} loadedEvent - Evento que ejecutará cuando la imagen se cargue, devolverá la data generada
             */
            loadImage(file, selector, loadedEvent = (param1, param2) => null){
                const reader = new FileReader();
                reader.onload = (e) => {
                    $(selector).css('background-image', `url(${ e.target.result })`);
                    loadedEvent(e.target.result, e.target.result.substring(e.target.result.indexOf(',') + 1));
                }
                reader.readAsDataURL(file);
            },
            isAuthenticated () {
                return localStorage.getItem("csrf_tokenizer") != null && JSON.parse(window.atob(localStorage.getItem("csrf_tokenizer")))?.id;
            }
        };
    },
};
